import { Component } from 'react';
import {connect} from 'react-redux';
import {getTimestamp} from '../utils'

class WebAudioRecorder extends Component {
    componentDidMount(){
        navigator.getUserMedia = navigator.getUserMedia ||
          navigator.webkitGetUserMedia ||
          navigator.mozGetUserMedia ||
          navigator.msGetUserMedia

        if(navigator.getUserMedia && Worker && window.AudioContext){
        } else {
            return this.props.dispatch( {type: 'RECORDER_SET_NOT_AVAILABLE'} )
        }
        this.worker = new Worker('/worker-realtime.js')
        this.microphone = null
        this.audioContext = new AudioContext()
        this.processor = this.audioContext.createScriptProcessor(0,1,1)

        this.currentCallback = null
        let that = this
        this.worker.onmessage = function (e) {
            switch (e.data.cmd) {
                case 'end':
                    if (that.currentCallback) {
                        let blob = new Blob(e.data.buf, {type: 'audio/mp3'})
                        let a = new FileReader()
                         a.onload = function (e) {
                            let dataUri = e.target.result
                            that.currentCallback(blob, dataUri)
                            that.currentCallback = null
                        }
                        a.readAsDataURL(blob)
                    }
                    console.log('MP3 data size', e.data.buf.length)
                    break
                case 'error':
                    console.log(e.data.error)
                    break
                default :
                    console.log('I just received a message I know not how to handle.', e.data)
            }
        }

        that = this

        let config = {
            sampleRate: this.audioContext.sampleRate
        }
        this.worker.postMessage({cmd: 'init', config: config})

        that.processor.onaudioprocess = e=> {
            let buf = e.inputBuffer.getChannelData(0)
            that.worker.postMessage({cmd: 'encode', buf: buf})
        }
    }


    componentWillUnmount(){
        this.microphone && this.microphone.disconnect()
        this.processor && this.processor.disconnect()
        this.worker && this.worker.terminate()
        this.audioContext && this.audioContext.close()
    }

    componentDidUpdate(){
		const {audioRecorder, dispatch, account, reply} = this.props;
        let microphone = this.microphone
        let processor = this.processor
        let audioContext = this.audioContext
        let worker = this.worker

		if(audioRecorder.recorderState === 'check'){
            if(navigator.getUserMedia && Worker && window.AudioContext){
            } else {
                console.log('---not available')
                return this.props.dispatch( {type: 'RECORDER_SET_NOT_AVAILABLE'} )
            }

            var that = this
            navigator.getUserMedia( {
                "audio": {
                    "mandatory": {
                        "googEchoCancellation": true,
                        "googAutoGainControl": true,
                        "googNoiseSuppression": true,
                        "googHighpassFilter": true,
                    },
                    "optional": []
                },
            } , (stream)=>{
                that.microphone = audioContext.createMediaStreamSource(stream)
                dispatch({
                    type: 'RECORDER_SET_READY'
                })
            }, (e) => {
                console.log(e)
            })
        }
		if(audioRecorder.recorderState === 'start'){
            microphone.connect(processor)
            processor.connect(audioContext.destination)
            dispatch({
                type: 'RECORDER_SET_RECORDING'
            })
		}
		if(audioRecorder.recorderState === 'stop' || audioRecorder.recorderState === 'force_stop'){
            if(processor && microphone){
                microphone.disconnect()
                processor.disconnect()
                const duration = Math.floor((Date.now() - audioRecorder.startRecordTime)/1000)
                worker.postMessage({cmd: 'finish'})
                const {timestampDelta} = this.props;
                let timestamp = getTimestamp(timestampDelta);
                this.currentCallback = (blob, dataUri) => {
                    dispatch({
                        type: 'ML_SEND_MESSAGE',
                        payload: {
                            type: 'voice',
                            account: account,
                            audio: blob,
                            content: dataUri,
                            length: duration,
                            reply: reply,
                            from: 'pc',
                            timestamp: timestamp,
                        }
                    })
                    if(reply){
                        dispatch({
                            type: 'CLASSROOM_SET_REPLY',
                            payload: null
                        })
                    }
                    dispatch({
                        'type': audioRecorder.recorderState === 'stop' ? 'RECORDER_SET_READY':'RECORDER_START_RECORD'
                    })
                }
            }
		}

		if (audioRecorder.recorderState === 'cancel') {
        if(processor && microphone) {
            microphone.disconnect();
            processor.disconnect();
            worker.postMessage({cmd: 'finish'});
            dispatch({type: 'RECORDER_SET_READY'});
        }
    }
	}

    render(){
        return null
    }
}

export default  connect((state) => ({
	audioRecorder: state.audioRecorder,
	account: state.account,
	reply: state.classroom.reply,
  timestampDelta: state.classroom.timestampDelta,
}))(WebAudioRecorder);




// WEBPACK FOOTER //
// ./src/components/WebAudioRecorder.js